import {defaultPulseCheckApi} from '~src/services/ApiController';
import {AxiosResponse} from "axios";
import {ScalesRespI} from "~src/interfaces/scale.interface";

export const getScales = async (): Promise<ScalesRespI> => { // getScales is a misnomer if visualization is fixed
  const resp: AxiosResponse<ScalesRespI> = await defaultPulseCheckApi.getScales({per_page: 1000});

  return resp.data;
};
